import { useQuery } from "@apollo/client";
import { LoadingSpinner, Modal } from "pepsico-ds";
import { useContext } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { loadCampaignById } from "../../../graphql/queries/loadCampaignById";
import { getDateWithFormat } from "../../../utils/commons";
import "./CampaignDetailsModal.scss";

const CampaignDetailsModal = ({ showModal, onClose, campaignId }) => {
  const { programTimezone } = useContext(GlobalConfigContext) || {};

  const { data: campaignData, loading } = useQuery(loadCampaignById, {
    variables: { id: campaignId },
    skip: !campaignId,
    fetchPolicy: "cache-and-network",
  });

  const campaign = campaignData?.loadCampaignById;

  return (
    <Modal
      showModal={showModal}
      onCloseModal={onClose}
      primaryButtonProps={{
        size: "medium",
        text: "Close",
        variant: "primary",
        onClick: onClose,
      }}
      showSecondaryButton={false}
      showTertiaryButton={false}
      showLink={false}
      title="Campaign Details"
    >
      <div className="campaign-details-modal">
        {loading ? (
          <div className="loading-container">
            <LoadingSpinner
              data-testid="loading-spinner"
              size={{
                height: "2rem",
                width: "2rem",
              }}
            />
          </div>
        ) : campaign ? (
          <div className="campaign-details-content">
            <div className="campaign-detail-item">
              <span className="detail-label">Campaign Name:</span>
              <span className="detail-value" data-testid="detail-value">
                {campaign.title || "N/A"}
              </span>
            </div>
            <div className="campaign-detail-item">
              <span className="detail-label">Campaign Short Name:</span>
              <span className="detail-value" data-testid="detail-value">
                {campaign.titleShort || "N/A"}
              </span>
            </div>
            <div className="campaign-detail-item">
              <span className="detail-label">Start Date:</span>
              <span className="detail-value" data-testid="detail-value">
                {campaign.activeStartDate && programTimezone
                  ? getDateWithFormat(
                      campaign.activeStartDate,
                      programTimezone,
                      "DD/MM/YYYY"
                    )
                  : "N/A"}
              </span>
            </div>
            <div className="campaign-detail-item">
              <span className="detail-label">End Date:</span>
              <span className="detail-value" data-testid="detail-value">
                {campaign.activeEndDate && programTimezone
                  ? getDateWithFormat(
                      campaign.activeEndDate,
                      programTimezone,
                      "DD/MM/YYYY"
                    )
                  : "N/A"}
              </span>
            </div>
            <div className="campaign-detail-item">
              <span className="detail-label">Current Status:</span>
              <span className="detail-value" data-testid="detail-value">
                {campaign.campaignStatus || "N/A"}
              </span>
            </div>
          </div>
        ) : (
          <div className="no-data">No campaign details available</div>
        )}
      </div>
    </Modal>
  );
};

export default CampaignDetailsModal;
